import styled from 'styled-components/native';

interface BlurredOverlayProps {
  enabled: boolean;
}

const BlurredOverlay = styled.View<BlurredOverlayProps>`
  flex: 1;
  height: 100%;
  width: 100%;
  filter: ${props => (props.enabled ? 'blur(4px)' : null)};
`;

export default BlurredOverlay;
